export default "__VITE_ASSET__CltVWRdM__"